import Vue from 'vue';
import 'amfe-flexible';
import App from './App.vue';
// import router from "./router";
import store from "./store";
import '@/styles/base.less';
import 'vant/lib/icon/local.css';

import {Toast, Dialog, Tab, Tabs, Swipe, SwipeItem} from 'vant';
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.config.productionTip = false;

new Vue({
  // router,
  store,
  render: h => h(App),
}).$mount('#app');